<template>
  <div class="w-100">
    <proa-heading>{{ $t('pages.meeting.heading') }}</proa-heading>
    <invited-meetings/>
    <b-container fluid class="p-0">
      <b-row no-gutters>
        <b-col v-if="cafeVideoRoomMaster" cols="12" class="mt-4 pt-3">
          <proa-heading sub class="mb-3 pb-1">{{ $t('pages.meeting.cafe') }}</proa-heading>
          <proa-card
            :class="['room-card cafe', { 'active': activeVideoRoomMasterId == 'cafe' }]"
            @mouseover.native="onMouseOverVideoRoomMaster('cafe')"
            @mouseleave.native="onMouseLeaveVideoRoomMaster"
            @click.native="onClickVideoRoomMaster('cafe')"
          >
            <div class="room-name cafe">
              <img :src="require('@/assets/images/icons/cafe.png')" />
              <span>{{ $t('pages.mySpace.cafe') }}</span>
            </div>
            <div class="users d-none d-md-block">
              <div class="tooltip-padding" @mouseover.stop="" @mouseleave.stop="" @click.stop=""></div>
              <div class="users-scroll-wrapper">
                <div
                  v-for="user in cafeVideoRoomMaster.getCurrentCafeInfoUsers()"
                  :key="user.id"
                  class="avatar-wrapper"
                >
                  <proa-tooltip>
                    <proa-avatar
                      :src="require('@/assets/images/avatar_default.png')"
                      size="sm"
                    />
                    <template v-slot:tooltip>
                      <div class="avatar-name">
                        {{ user.meta.displayName }}
                      </div>
                    </template>
                  </proa-tooltip>
                </div>
              </div>
            </div>
            <div class="in-use">{{ `${cafeVideoRoomMaster.getCurrentCafeInfoUsers().length}／${cafeVideoRoomMaster.roomCapacity}${$t('common.person') + $t('common.inUse')}` }}</div>
            <div v-if="signedInUser.creatable" class="card-end-button">
              <proa-button
                @mouseover.native.stop="activeVideoRoomMasterId = null"
                @click.native.stop="inviteCafeRoomMembersModal = true"
              >
                {{ $t('common.inviteNow') }}
              </proa-button>
            </div>
          </proa-card>
        </b-col>
        <b-col v-if="signedInUser.creatable" cols="12" class="mt-4 pt-3">
          <div class="d-flex align-items-end justify-content-between mb-3 pb-1">
            <proa-heading sub>{{ $t('pages.meeting.meetingRooms') }}</proa-heading>
            <proa-button @click.native="reservationCalendarModal = true">{{ $t('common.reservationCalendar') }}</proa-button>
          </div>
          <proa-card
            v-for="normalVideoRoomMaster in normalVideoRoomMasters"
            :key="normalVideoRoomMaster.id"
            :class="['room-card mb-2', { 'active': activeVideoRoomMasterId == normalVideoRoomMaster.id }]"
            @mouseover.native="onMouseOverVideoRoomMaster(normalVideoRoomMaster.id)"
            @mouseleave.native="onMouseLeaveVideoRoomMaster"
            @click.native="onClickVideoRoomMaster(normalVideoRoomMaster.id)"
          >
            <template v-if="$mq==='sm'">
              <div class="w-100">
                <div class="d-flex align-items-end justify-content-between mb-2">
                  <div class="room-name">
                    <img :src="require('@/assets/images/icons/meeting_room.png')" />
                    <span>{{ normalVideoRoomMaster.roomName }}</span>
                  </div>
                  <div class="capaciry">
                    {{ $t('common.max') + normalVideoRoomMaster.roomCapacity + $t('common.person') }}
                  </div>
                </div>
                <div class="users mb-2">
                  <div v-if="normalVideoRoomMaster.scheduled()" class="users-scroll-wrapper">
                    <div v-for="user in normalVideoRoomMaster.getLatestRoomInfoUsers()" :key="user.id" class="avatar-wrapper">
                      <div class="tooltip-padding" @mouseover.stop="" @mouseleave.stop="" @click.stop=""></div>
                      <proa-tooltip v-if="user.temporaryGuest">
                        <proa-avatar
                          :src="require('@/assets/images/avatar_default.png')"
                          size="sm"
                          guest
                        />
                        <template v-slot:tooltip>
                          <div class="avatar-name">
                            {{ user.meta.displayName }}
                          </div>
                        </template>
                      </proa-tooltip>
                      <proa-tooltip v-else>
                        <proa-avatar
                          :src="user.meta.avatar || require('@/assets/images/avatar_default.png')"
                          size="sm"
                        />
                        <template v-slot:tooltip>
                          <div class="avatar-name">
                            {{ user.meta.displayName }}
                          </div>
                        </template>
                      </proa-tooltip>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <div class="scheduled">
                    <span v-if="normalVideoRoomMaster.inDuration()" class="in-duration">
                      {{ new Date(normalVideoRoomMaster.meta.latestRoomInfo.startAt) | moment('HH:mm') }}〜{{ new Date(normalVideoRoomMaster.meta.latestRoomInfo.endAt) | moment('HH:mm') }}
                    </span>
                    <span v-else-if="normalVideoRoomMaster.scheduled()">
                      {{ new Date(normalVideoRoomMaster.meta.latestRoomInfo.startAt) | moment('HH:mm') }}〜利用予定
                    </span>
                    <span v-else>本日利用予定なし</span>
                  </div>
                  <div class="card-end-button">
                    <proa-button
                      @click.native.stop="onClickVideoRoomReservation(normalVideoRoomMaster.id)"
                      @mouseover.native.stop="activeVideoRoomMasterId = null"
                    >
                      {{ $t('common.newReservation') }}
                    </proa-button>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="room-name">
                <img :src="require('@/assets/images/icons/meeting_room.png')" />
                <span>{{ normalVideoRoomMaster.roomName }}</span>
              </div>
              <div class="capaciry">
                {{ $t('common.max') + normalVideoRoomMaster.roomCapacity + $t('common.person') }}
              </div>
              <div class="scheduled">
                <span v-if="normalVideoRoomMaster.inDuration()" class="in-duration">
                  {{ new Date(normalVideoRoomMaster.meta.latestRoomInfo.startAt) | moment('HH:mm') }}〜{{ new Date(normalVideoRoomMaster.meta.latestRoomInfo.endAt) | moment('HH:mm') }}
                </span>
                <span v-else-if="normalVideoRoomMaster.scheduled()">
                  {{ new Date(normalVideoRoomMaster.meta.latestRoomInfo.startAt) | moment('HH:mm') }}〜利用予定
                </span>
                <span v-else>本日利用予定なし</span>
              </div>
              <div class="users">
                <div v-if="normalVideoRoomMaster.scheduled()" class="users-scroll-wrapper">
                  <div v-for="user in normalVideoRoomMaster.getLatestRoomInfoUsers()" :key="user.id" class="avatar-wrapper">
                    <div class="tooltip-padding" @mouseover.stop="" @mouseleave.stop="" @click.stop=""></div>
                    <proa-tooltip v-if="user.temporaryGuest">
                      <proa-avatar
                        :src="require('@/assets/images/avatar_default.png')"
                        size="sm"
                        guest
                      />
                      <template v-slot:tooltip>
                        <div class="avatar-name">
                          {{ user.meta.displayName }}
                        </div>
                      </template>
                    </proa-tooltip>
                    <proa-tooltip v-else>
                      <proa-avatar
                        :src="user.meta.avatar || require('@/assets/images/avatar_default.png')"
                        size="sm"
                      />
                      <template v-slot:tooltip>
                        <div class="avatar-name">
                          {{ user.meta.displayName }}
                        </div>
                      </template>
                    </proa-tooltip>
                  </div>
                </div>
              </div>
              <div class="card-end-button">
                <proa-button
                  @click.native.stop="onClickVideoRoomReservation(normalVideoRoomMaster.id)"
                  @mouseover.native.stop="activeVideoRoomMasterId = null"
                >
                  {{ $t('common.newReservation') }}
                </proa-button>
              </div>
            </template>
          </proa-card>
        </b-col>
      </b-row>
    </b-container>
    <select-member-modal
      v-if="cafeVideoRoomMaster && newCafeRoom"
      :modal="inviteCafeRoomMembersModal"
      :userIds="newCafeRoom.userIds"
      :upperLimit="cafeVideoRoomMaster.roomCapacity - newCafeRoom.userIds.length"
      type="inviteCafeRoom"
      @close="inviteCafeRoomMembersModal = false"
      @confirm="addCafeRoomUserIds"
    />
    <select-reservation-at-by-day-modal
      :modal="reservationCalendarModal"
      @close="reservationCalendarModal = false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VideoRoomMaster from '@/store/models/VideoRoomMaster'
import VideoRoom from '@/store/models/VideoRoom'

import InvitedMeetings from '@/components/organisms/InvitedMeetings'
import SelectMemberModal from '@/components/organisms/SelectMemberModal'
import SelectReservationAtByDayModal from '@/components/organisms/SelectReservationAtByDayModal'

export default {
  name: 'IndexMeeting',
  components: {
    InvitedMeetings,
    SelectMemberModal,
    SelectReservationAtByDayModal
  },
  computed: {
    normalVideoRoomMasters: function() {
      return VideoRoomMaster.query().where('roomType', 'normalRoom').orderBy('roomCapacity', 'desc').get()
    },
    cafeVideoRoomMaster: function() {
      return VideoRoomMaster.query().where('roomType', 'cafeRoom').first()
    },
    ...mapGetters({
      signedInUser: 'auth/signedInUser'
    })
  },
  data(){
    return {
      initialized: false,
      inviteCafeRoomMembersModal: false,
      reservationCalendarModal: false,
      newCafeRoom: null,
      videoRoomMastersReloadInterval: null,
      activeVideoRoomMasterId: null
    }
  },
  methods: {
    onMouseOverVideoRoomMaster: function(id) {
      this.activeVideoRoomMasterId = id
    },
    onMouseLeaveVideoRoomMaster: function() {
      this.activeVideoRoomMasterId = null
    },
    onClickVideoRoomMaster: function(id) {
      if (id === 'cafe') {
        this.$router.push({ name: 'indexMeetingReservations', params: { id: this.cafeVideoRoomMaster.id } })
      } else {
        const videoRoomMaster = VideoRoomMaster.find(id)
        if (videoRoomMaster.inDuration()) {
          this.$router.push({ name: 'showMeetingReservations', params: {
            videoRoomMasterId: id,
            id: videoRoomMaster.meta.latestRoomInfo.id,
            returnPath: 'meeting'
          }})
        } else {
          this.$router.push({ name: 'indexMeetingReservations', params: { id: id } })
        }
      }
    },
    onClickVideoRoomReservation: function(id) {
      this.$router.push({ name: 'newMeetingReservations', params: { id: id } })
    },
    async addCafeRoomUserIds({ userIds }) {
      this.inviteCafeRoomMembersModal = false
      this.newCafeRoom.userIds = this.newCafeRoom.userIds.concat(userIds)
      const createdCafeRoomId = await this.apiPostVideoRoom({
        videoRoomMasterId: this.cafeVideoRoomMaster.id,
        attributes: this.newCafeRoom
      })
      if (createdCafeRoomId) {
        this.$router.push({ name: 'indexRoom', params: { videoRoomMasterId: this.cafeVideoRoomMaster.id, id: createdCafeRoomId } })
      }
    },
    ...mapActions({
      apiGetVideoRoomMasters: 'entities/videoRoomMasters/index',
      apiPostVideoRoom: 'entities/videoRooms/create'
    })
  },
  async created () {
    if (VideoRoomMaster.exists()) this.initialized = true

    await this.apiGetVideoRoomMasters()

    this.newCafeRoom = VideoRoom.skeleton()
    this.newCafeRoom.userIds = [this.signedInUser.id]

    this.initialized = true

    // NOTE: 10分に一度VideoRoomMastersを再取得
    this.videoRoomMastersReloadInterval = setInterval(() => {
      this.apiGetVideoRoomMasters()
    }, 600000)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 40px;

  .loading {
    width: 80px;
    height: 80px;
  }
}

.invited-meetings-container {
  padding: 0 !important;
  margin-top: 30px !important;

  @include mq(md) {
    padding-top: 1rem !important;
    margin-top: 1.5rem !important;
  }
}

.room-card {
  height: auto;
  padding: 15px;
  display: flex;
  align-items: center;
  cursor: pointer;

  @include mq(md) {
    height: 80px;
    padding: 0 20px;
  }

  &.active {
    background-color: $light-gray-color;
  }

  .room-name {
    color: $secondary-color;
    flex-shrink: 0;
    font-weight: 600;
    display: flex;
    flex-basis: auto;

    @include mq(md) {
      &:not(.cafe) {
        flex-basis: 20%;
      }
    }

    img {
      width: 20px;
      height: 20px;
      margin-right: 5px;

      @include mq(md) {
        margin-right: 10px;
      }
    }
  }

  .capaciry {
    color: $secondary-color;
    flex-shrink: 0;
    flex-basis: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100% - 30px);
    border: none;

    @include mq(md) {
      border: solid $light-border-color;
      border-width: 0 1px 0 1px;
    }
  }

  .scheduled {
    padding: 0;
    color: $secondary-color;
    flex-shrink: 0;
    flex-basis: auto;
    text-align: center;

    @include mq(md) {
      padding: 0 20px;
      flex-basis: 15%;
    }
    .in-duration {
      font-weight: 600;
    }
  }

  .users {
    flex-grow: 1;
    width: 100%;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include mq(md) {
      padding-bottom: 22px;
      margin-bottom: 16px;

      .tooltip-padding {
        height: 40px;
        background-color: transparent;
        cursor: auto;
      }
    }

    .users-scroll-wrapper {
      display: flex;
      padding-top: 10px;

      @include mq(md) {
        padding: 0 20px;
      }
    }

    .avatar-wrapper {
      margin-right: 5px;
      .avatar-name {
        max-width: 100px;
        font-size: 11px;
        white-space: nowrap;
        overflow-x: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  &.cafe .users {
    flex-grow: 0;
  }

  .in-use {
    color: $secondary-color;
    display: flex;
    align-items: center;
    flex-grow: 1;
    white-space: nowrap;
    margin-left: 20px;
  }

  .card-end-button {
    margin-left: 20px;
    flex-shrink: 0;
  }
}
</style>
